// import './_language.js';

window.addEventListener("load", function () {
   

   
    // Khởi tạo menu click handlers
  

});

